var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "analytics 1",
    clipPath: "url(#clip0_134_1375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.6992 18.6484V2.60156C8.81959 2.60156 0.812988 10.6082 0.812988 20.4878C0.812988 24.958 2.45719 29.0426 5.16899 32.1784L18.6992 18.6484Z",
    fill: "#43D3E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.5385 20.4877L7.0083 34.0177C10.1437 36.7293 14.2279 38.3737 18.6991 38.3737C28.5787 38.3737 36.5853 30.3639 36.5853 20.4875L20.5385 20.4877Z",
    fill: "#F96232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.821 17.0732H15.447V18.6992H13.821V17.0732ZM10.5692 17.0732H12.1952V18.6992H10.5692V17.0732ZM7.31699 17.0732H8.94299V18.6992H7.31699V17.0732ZM24.147 12.0056L32.337 3.8154C31.9046 3.47586 31.4569 3.15633 30.9952 2.8578L22.6456 11.2074C23.1677 11.4305 23.67 11.6976 24.147 12.0056ZM21.3008 0V2.2994L23.465 0.135C22.747 0.0465847 22.0242 0.00150303 21.3008 0ZM27.979 16.5418L36.3292 8.1916C36.0307 7.72989 35.7112 7.28215 35.3716 6.8498L27.1812 15.0402C27.4889 15.5174 27.7558 16.0197 27.979 16.5418ZM25.0812 0.404L21.3008 4.1844V6.4838L26.8892 0.895C26.2956 0.699484 25.6921 0.535587 25.0812 0.404ZM26.3788 13.958L34.51 5.8266C34.1442 5.42639 33.7606 5.04281 33.3604 4.677L25.229 12.8084C25.6423 13.1603 26.0268 13.5448 26.3788 13.958ZM39.052 15.7218L36.8878 17.886H39.187C39.187 17.1532 39.1376 16.4316 39.052 15.7218ZM38.292 12.2976L32.7036 17.886H35.003L38.7834 14.1056C38.6514 13.4947 38.4874 12.8912 38.292 12.2976ZM37.0344 9.3712L28.5196 17.8862H30.8188L37.7814 10.9236C37.5575 10.3944 37.3082 9.87636 37.0344 9.3712ZM28.2638 1.4056L21.3008 8.3682V10.6676L29.8158 2.1526C29.3108 1.87875 28.7929 1.62946 28.2638 1.4056ZM30.2958 38.374H36.5852V40H30.2958V38.374ZM36.5854 36.8496H29.9594L25.2738 32.164L26.424 31.0144L30.6326 35.2236H36.5854V36.8496ZM0.812988 0.9756H7.10239V2.6016H0.812988V0.9756ZM10.9744 9.9612L6.76579 5.752H0.812988V4.126H7.43899L12.1246 8.8116L10.9744 9.9612Z",
    fill: "#242D3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_1375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.c079c4c4666eeb1238f0352e0a1cf8b8.svg";
export { ForwardRef as ReactComponent };